import { useTranslation } from 'react-i18next';
import { IconSize } from '../../../constant/IconSize.constant';
import { OcmConnection } from '../../../stores/types/ocm.interface';
import { ColorType, Icon, Label, LabelType } from '../../_ui';
import { getConnectorAbbr, getConnectorIcon } from '../utils';
import { FINDER_STATUS_STYLE, getStatusLabelKey } from './statusStyles';
import { getConnectorTypeFromOcm } from './utils/connectors';
import { getConnectionLevel, getFinderStatus, isDcConnection } from './utils/status';

interface NearbyChargerConnectionRowProps {
  connection: OcmConnection;
}

export const NearbyChargerConnectionRow = ({ connection }: NearbyChargerConnectionRowProps) => {
  const { t } = useTranslation();
  const connectorType = getConnectorTypeFromOcm(connection.ConnectionTypeID);
  const level = getConnectionLevel(connection);
  const status = getFinderStatus(connection.StatusType);
  const statusLabel = t(getStatusLabelKey(status));
  const { dotClassName } = FINDER_STATUS_STYLE[status];

  const connectorLabel: string = connectorType
    ? getConnectorAbbr(connectorType)
    : connection.ConnectionType?.Title ?? t('nearby_chargers_unknown_connector');
  const speed = [
    level ? t(`nearby_chargers_level_${level}`) : null,
    connection.PowerKW
      ? `${connection.PowerKW} kW ${isDcConnection(connection) ? 'DC' : 'AC'}`
      : null,
    `×${connection.Quantity ?? 1}`,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <div className='flex flex-row items-center justify-between gap-2'>
      <div className='flex flex-row items-center gap-1 min-w-0'>
        {connectorType && (
          <Icon
            src={getConnectorIcon(connectorType)}
            size={IconSize.SIZE_16x16}
            color={ColorType.GREY6}
          />
        )}
        <Label
          text={connectorLabel}
          type={LabelType.LABEL_XS}
          color={ColorType.GREY6}
          className='truncate'
        />
      </div>
      <div className='flex flex-row items-center gap-2 shrink-0'>
        <Label text={speed} type={LabelType.BODY4} color={ColorType.GREY6} />
        <span
          className={`w-2 h-2 rounded-full ${dotClassName}`}
          title={statusLabel}
          aria-label={statusLabel}
          role='img'
        />
      </div>
    </div>
  );
};
